module.exports = __webpack_public_path__ + "3b03924fd200ca6ace12f047ceeef525.MP3";